<template>
  <app-filters-drawer :model-value="internalValue" :title="$t('common.filters')"
                      data-locator="search-page-filters-pane"
                      @close="internalValue = false"
                      @clear="handleFiltersClear"
                      @apply="handleFiltersSubmit({ ...searchPageFilters })"
  >
    <template #body>
      <AppAggregateFormBuilder
        :formData="searchPageFilters"
        :aggregate-scheme="searchPageResultsAggregations"
        @update:fieldValue="handleFieldValueUpdate($event)"
      />
    </template>
  </app-filters-drawer>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue"
import { useStore } from "vuex"

import AppAggregateFormBuilder from "@/common/form-builder/AppAggregateFormBuilder.vue"
import { initFormData } from "@/common/form-builder/formTypes";
import { SET_SEARCH_PAGE_FILTERS } from "@/store/modules/documents/mutation_types";


const store = useStore()
const searchPageFilters = computed(() => store.state.documents.searchPageFilters)
const searchPageResultsAggregations = ref(store.state.documents.searchPageResultsAggregations)

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  lastNewQuery: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue', 'update:filters'])

const internalValue = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
  },
})

watch(
  () => props.lastNewQuery,
  () => {
    searchPageResultsAggregations.value = store.state.documents.searchPageResultsAggregations
  },
)

watch(
  () => searchPageResultsAggregations.value,
  (aggregateScheme) => {
    store.commit(`documents/${SET_SEARCH_PAGE_FILTERS}`, initFormData(aggregateScheme))
  },
  { deep: true, immediate: true },
)

const handleFiltersSubmit = (formData: Record<string, any>) => {
  emit('update:filters', formData)
  internalValue.value = false
}

const handleFieldValueUpdate = ({ key, value }: { key: string, value: any }) => {
  const updatedFormData = {
    ...searchPageFilters.value,
    [key]: value,
  }

  store.commit(`documents/${SET_SEARCH_PAGE_FILTERS}`, updatedFormData)
}

const handleFiltersClear = () => {
  store.commit(`documents/${SET_SEARCH_PAGE_FILTERS}`, initFormData(searchPageResultsAggregations.value))
}

</script>
